"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateOrCancelOpenInspectionDtoActionEnum = void 0;
exports.instanceOfUpdateOrCancelOpenInspectionDto = instanceOfUpdateOrCancelOpenInspectionDto;
exports.UpdateOrCancelOpenInspectionDtoFromJSON = UpdateOrCancelOpenInspectionDtoFromJSON;
exports.UpdateOrCancelOpenInspectionDtoFromJSONTyped = UpdateOrCancelOpenInspectionDtoFromJSONTyped;
exports.UpdateOrCancelOpenInspectionDtoToJSON = UpdateOrCancelOpenInspectionDtoToJSON;
exports.UpdateOrCancelOpenInspectionDtoToJSONTyped = UpdateOrCancelOpenInspectionDtoToJSONTyped;
/**
 * @export
 */
exports.UpdateOrCancelOpenInspectionDtoActionEnum = {
    Update: 'update',
    Cancel: 'cancel'
};
/**
 * Check if a given object implements the UpdateOrCancelOpenInspectionDto interface.
 */
function instanceOfUpdateOrCancelOpenInspectionDto(value) {
    if (!('action' in value) || value['action'] === undefined)
        return false;
    return true;
}
function UpdateOrCancelOpenInspectionDtoFromJSON(json) {
    return UpdateOrCancelOpenInspectionDtoFromJSONTyped(json, false);
}
function UpdateOrCancelOpenInspectionDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'action': json['action'],
        'newInspectionStartTime': json['newInspectionStartTime'] == null ? undefined : json['newInspectionStartTime'],
        'newInspectionEndTime': json['newInspectionEndTime'] == null ? undefined : json['newInspectionEndTime'],
        'reason': json['reason'] == null ? undefined : json['reason'],
    };
}
function UpdateOrCancelOpenInspectionDtoToJSON(json) {
    return UpdateOrCancelOpenInspectionDtoToJSONTyped(json, false);
}
function UpdateOrCancelOpenInspectionDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'action': value['action'],
        'newInspectionStartTime': value['newInspectionStartTime'],
        'newInspectionEndTime': value['newInspectionEndTime'],
        'reason': value['reason'],
    };
}
